import firebase from "firebase/app";
import "firebase/firestore";
import { useEffect, useMemo } from "react";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";

import { configSelector } from "./config";

export const useFirebase = (): firebase.app.App | null => {
  const { environment, firebase: firebaseConfig } =
    useRecoilValue(configSelector);

  const app = useMemo(() => {
    if (!firebaseConfig) {
      return null;
    }
    let app;
    try {
      app = firebase.app(environment);
    } catch (error) {
      app = firebase.initializeApp(firebaseConfig, environment);
    }
    return app;
  }, [environment]);

  return app;
};

export const topAddressesAtom = atom({
  key: "topAddresses",
  default: [],
});

export const useTopAddresses = () => {
  const app = useFirebase();
  const setTopAddresses = useSetRecoilState(topAddressesAtom);

  useEffect(() => {
    if (!app) {
      return;
    }

    const cancel = app
      .firestore()
      .collection("accounts")
      .orderBy("totalSupplySortable", "desc")
      .limit(10)
      .onSnapshot({
        next: (snaps) => {
          setTopAddresses(
            snaps.docs.map((doc) => ({
              ...doc.data(),
              address: doc.id,
            }))
          );
        },
      });

    return cancel;
  }, [app.name]);
};
